import React, { useState } from "react";
import { FaPhoneAlt, FaEnvelope, FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/logo.png";
import "../App.css";
/* 1. Import useLocation */
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  /* 2. Initialize location */
  const location = useLocation();

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen((prev) => !prev);
  };

  const scrollToTrail = () => {
    const section = document.getElementById("trail-section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="nav-wrapper">
      <div className="nav-row-1">
        <div className="logo-block">
          <img src={logo} alt="Logo" className="nav-logo" />
          <div className="logo-divider-second"></div>
        </div>

        <div className="nav-right-group">
          <div className="contact-item">
            {/* Phone Number Link */}
            <a
              href="tel:07548889409"
              className="contact-item"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <FaPhoneAlt className="contact-icon" />
              <span>07548 889409</span>
            </a>
          </div>

          <div className="contact-item">
            <a
              href="mailto:infocoreflowfit@gmail.com"
              className="contact-item"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <FaEnvelope className="contact-icon" />
              <span>infocoreflowfit@gmail.com</span>
            </a>
          </div>

          <button
            className="nav-toggle"
            onClick={() => setIsMenuOpen((prev) => !prev)}
            aria-label="Toggle Menu"
          >
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      <nav className={`nav-row-2 ${isMenuOpen ? "open" : ""}`}>
        <ul className="nav-links">
          <li>
            <Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link>
          </li>
          <li>
            <Link
              to="/#about-section"
              onClick={() => setIsMenuOpen(false)}
            >
              About Me
            </Link>
          </li>

          <li className="dropdown">
            <span
              className={`dropdown-toggle ${isDropdownOpen ? "active" : ""}`}
              onClick={toggleDropdown}
            >
              Services
            </span>
            <ul className={`dropdown-menu ${isDropdownOpen ? "show" : ""}`}>
              <li><Link to="/calisthenics" onClick={() => { setIsDropdownOpen(false); setIsMenuOpen(false); }}>Calisthenics</Link></li>
              <li><Link to="/breathwork" onClick={() => { setIsDropdownOpen(false); setIsMenuOpen(false); }}>Breathwork</Link></li>
              <li><Link to="/mobility" onClick={() => { setIsDropdownOpen(false); setIsMenuOpen(false); }}>Mobility</Link></li>
              <li><Link to="/nutrition" onClick={() => { setIsDropdownOpen(false); setIsMenuOpen(false); }}>Nutrition</Link></li>
            </ul>
          </li>

          {/* <li>
            <a href="/allblogs" onClick={() => setIsMenuOpen(false)}>Journal</a>
          </li> */}
          <li>
            <Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact Me</Link>
          </li>
        </ul>

        {/* 3. Conditional Rendering: Only show if path is "/" */}
        {location.pathname === "/" && (
          <button className="cta-btn nav-cta ms-4" onClick={scrollToTrail}>
            Try for FREE
          </button>
        )}
      </nav>
    </header>
  );
};

export default Navbar;